import { render, staticRenderFns } from "./EventHistoryPage.vue?vue&type=template&id=017722a0&scoped=true&"
import script from "./EventHistoryPage.vue?vue&type=script&lang=js&"
export * from "./EventHistoryPage.vue?vue&type=script&lang=js&"
import style0 from "./EventHistoryPage.vue?vue&type=style&index=0&id=017722a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017722a0",
  null
  
)

export default component.exports